import React from 'react';

import { createURL } from '@sm/utils';
import { t } from '@sm/intl';
import {
  IconUsers,
  IconUserPlus,
  IconUser,
  IconChartDonut,
  IconWorkgroup,
  IconBlocks,
  IconGraduationHat,
  IconPulse,
  IconMobile,
  IconCart,
  IconGear
} from '@sm/wds-icons';

import TEAM_MENU_COPY from './TeamMenuCopy';

export const DEFAULT_MY_TEAM_MENU_SUB_ITEMS = {
  teamSummaryTab: false,
  manageUsersTab: false,
  addUsersTab: false,
  adminDashboardTab: false,
  divisionsTab: false,
  workgroupsTab: false,
  libraryTab: true,
  activityTab: false,
  offlineDevicesTab: false,
  manageCreditsTab: false,
  settingsTab: false
};

export const ACCOUNT_TYPES = {
  enterpriseAccount: 'enterpriseAccount',
  teamAccount: 'teamAccount'
};

export const USER_ROLES = {
  accountOwner: 'accountOwner',
  admin: 'admin',
  divisionAdmin: 'divisionAdmin',
  user: 'user'
};

export const SSO_STATE = {
  REQUIRED: 'REQUIRED'
};

export const TEAM_MEMBERSHIP_TYPE = {
  ACCOUNT_OWNER: 'ACCOUNT_OWNER'
};

export const TAB_IDS = {
  teamSummary: 'teamSummary',
  manageUsers: 'manageUsers',
  addUsers: 'addUsers',
  adminDashboard: 'adminDashboard',
  divisions: 'divisions',
  workgroups: 'workgroups',
  activity: 'activity',
  offlineDevices: 'offlineDevices',
  manageCredits: 'manageCredits',
  settings: 'settings',
  library: 'library',
  contributor: 'contributor'
};

export const getTeamMenuItemConfigs = utSource => ({
  [TAB_IDS.teamSummary]: {
    path: createURL('/team/', { ut_source: utSource }),
    name: t(TEAM_MENU_COPY.TEAM_SUMMARY),
    renderIcon: props => <IconUsers {...props} />,
    id: TAB_IDS.teamSummary
  },
  [TAB_IDS.manageUsers]: {
    path: createURL('/team/users/', { ut_source: utSource }),
    name: t(TEAM_MENU_COPY.MANAGE_USERS),
    renderIcon: props => <IconUser {...props} />,
    id: TAB_IDS.manageUsers
  },
  [TAB_IDS.addUsers]: {
    path: createURL('/team/add/', { ut_source: utSource }),
    name: t(TEAM_MENU_COPY.ADD_USERS),
    renderIcon: props => <IconUserPlus {...props} />,
    id: TAB_IDS.addUsers
  },
  [TAB_IDS.adminDashboard]: {
    path: createURL('/team/manage/users/', { ut_source: utSource }),
    name: t(TEAM_MENU_COPY.ADMIN_DASHBOARD),
    renderIcon: props => <IconChartDonut {...props} />,
    id: TAB_IDS.adminDashboard
  },
  [TAB_IDS.divisions]: {
    path: createURL('/team/divisions/', { ut_source: utSource }),
    name: t(TEAM_MENU_COPY.DIVISIONS),
    renderIcon: props => <IconBlocks {...props} />,
    id: TAB_IDS.divisions
  },
  [TAB_IDS.workgroups]: {
    path: createURL('/team/workgroups/all/', { ut_source: utSource }),
    name: t(TEAM_MENU_COPY.WORKGROUPS),
    renderIcon: props => <IconWorkgroup {...props} />,
    id: TAB_IDS.workgroups
  },
  [TAB_IDS.library]: {
    path: createURL('/team/library/', { ut_source: utSource }),
    name: t(TEAM_MENU_COPY.LIBRARY),
    renderIcon: props => <IconGraduationHat {...props} />,
    id: TAB_IDS.library
  },
  [TAB_IDS.activity]: {
    path: createURL('/team/activity/', { ut_source: utSource }),
    name: t(TEAM_MENU_COPY.ACTIVITY),
    renderIcon: props => <IconPulse {...props} />,
    id: TAB_IDS.activity
  },
  [TAB_IDS.offlineDevices]: {
    path: createURL('/team/devices/', { ut_source: utSource }),
    name: t(TEAM_MENU_COPY.OFFLINE_DEVICES),
    renderIcon: props => <IconMobile {...props} />,
    id: TAB_IDS.offlineDevices
  },
  [TAB_IDS.manageCredits]: {
    path: createURL('/team/manage_credits/', { ut_source: utSource }),
    name: t(TEAM_MENU_COPY.MANAGE_CREDITS),
    renderIcon: props => <IconCart {...props} />,
    id: TAB_IDS.manageCredits
  },
  [TAB_IDS.settings]: {
    path: createURL('/team/settings/', { ut_source: utSource }),
    name: t(TEAM_MENU_COPY.SETTINGS),
    renderIcon: props => <IconGear {...props} />,
    id: TAB_IDS.settings
  }
});
